import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AuthModule } from '../auth/auth.module';
import { OnlineIndicatorComponent } from './online-indicator/online-indicator.component';
import { OnlineStatusComponent } from './online-status.component';

@NgModule({
  imports: [CommonModule, AuthModule],
  declarations: [OnlineStatusComponent, OnlineIndicatorComponent],
  exports: [OnlineStatusComponent],
})
export class OnlineStatusModule {}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/ko/webapp/src/app/@shared/online-status/online-status.module.ts